// noinspection GraphQLUnresolvedReference,DuplicatedCode

import axios from 'axios'
import { gql } from 'graphql-request'

import { ImagenCloudProp } from '../../../base/interfaces'
import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'

export const query = gql`
  mutation ARTICULO_IMPORTAR($cds: Int!, $file: Upload!) {
    articuloImportar(cds: $cds, file: $file) {
      estado
      success
      detalle {
        fila
        columna
        errores
      }
    }
  }
`

/**
 * @description Importación de imagen al articulo
 * @param cds
 * @param file
 */
export const apiArticuloImportar = async (
  cds: number,
  file: File,
): Promise<{
  estado: string
  success: boolean
  detalle: { fila: string; columna: string; errores: string[] }[]
}> => {
  try {
    // const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)

    const variables = {
      cds,
      file: null,
    }
    const formData = new FormData()
    const operations = JSON.stringify({ query: query, variables })
    formData.append('operations', operations)
    const map = {
      '0': ['variables.file'],
    }
    formData.append('map', JSON.stringify(map))
    formData.append('0', file)

    const resp = await axios({
      url: import.meta.env.ISI_API_URL,
      headers: {
        authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      data: formData,
    })
      .then((data) => data.data)
      .catch((e) => {
        throw new Error(e)
      })
    return resp.data.articuloImportar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
